import { ReactComponent as Wpp } from '../../../assets/img/wpp.svg';
import { WppAlertButtonComponent, WppAlertButtonNumber } from "./styles";
import React from 'react';

export default function WppAlertButton({ number, ...props }) {
  return <>
    <WppAlertButtonComponent variant="tonal" {...props}>
      {number > 0 && <WppAlertButtonNumber>
        <div>
          {number}
        </div>
      </WppAlertButtonNumber>}
      <Wpp/>
      Pedidos de ajuda
    </WppAlertButtonComponent>
  </>
}